<template>
    <v-dialog v-model="dialog" persistent max-width="600px">
      <template v-slot:activator="{ on}">
        <div style="width:100%;">
          <v-btn
            color="primary"
            v-bind:disabled="isActive"
            v-on="on"
            x-large
            block
          >
          <v-icon x-large  left class="pr-5 ml-2" v-if="buttonIcon">{{buttonIcon}}</v-icon>
            {{buttonText}}
          </v-btn>
        </div>
      </template>
      <v-card>
        <v-card-title>
          <span class="headline">Выберите дату</span>
        </v-card-title>
        <v-subheader>Период для формирования отчета</v-subheader>
        <v-card-text>
            <v-form
                ref="form"
                v-model="valid"
            >
                <v-text-field
                v-model="dateStartText"
                label="Начало"
                type="date"
                :max = "maxDate"
                min = "2020-01-01"
                :rules="[v => !!v || 'Обязательное поле']"
                required
                ></v-text-field>
                <v-text-field
                v-model="dateEndText"
                label="Конец"
                type="date"
                :max = "maxDate"
                :disabled="!dateStart"
                min = "2020-01-01"
                :rules="[v => !!v || 'Обязательное поле', v => new Date(v) > dateStart || 'Дата окончания должна быть больше даты начала']"
                ></v-text-field>
                <v-select
                v-model="currentSystem"
                :items="Systems"
                :rules="[v => !!v || 'Обязательное поле']"
                label="Система ТК"
                required
                ></v-select>
            </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="dialog = false">Отмена</v-btn>
          <v-btn color="primary" :disabled="!valid" text @click="validate">Продолжить</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>
<script>
export default {
  props: {
    buttonText: String,
    buttonIcon: String,
    buttonSize: String,
    isActive: Boolean,
    rules: {
      required: false
    }
  },
  computed: {
    dateStart: function () {
      const date = new Date(this.dateStartText)
      const maxDate = new Date(this.maxDate)
      if (this.isValidDate(date)) {
        if (date < maxDate) {
          return date
        } else {
          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
          this.dateStartText = maxDate.toISOString().slice(0, 10)
          return new Date(maxDate)
        }
      } else {
        return null
      }
    },
    dateEnd: function () {
      const date = new Date(this.dateEndText)
      const maxDate = new Date(this.maxDate)
      if (this.isValidDate(date)) {
        if (date < maxDate) {
          return date
        } else {
          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
          this.dateEndText = maxDate.toISOString().slice(0, 10)
          return new Date(maxDate)
        }
      } else {
        return null
      }
    }
  },
  data: () => ({
    maxDate: (new Date()).toISOString().slice(0, 10),
    currentSystem: 'ППР',
    Systems: ['ППР', 'Опти24', 'Shell', 'Neste Oil', 'Роснефть'],
    valid: true,
    dateStartText: '',
    dateEndText: '',
    dialog: false
  }),
  methods: {
    validate () {
      this.$refs.form.validate()
      this.dialog = false
      this.$emit('onValidate', { dateStart: this.dateStart, dateEnd: this.dateEnd, currentSystem: this.currentSystem })
    },
    isValidDate (d) {
      return d instanceof Date && !isNaN(d)
    }
  },
  mounted () {
    this.currentSystem = localStorage.getItem('defaultCardSystem') ? localStorage.getItem('defaultCardSystem') : 'ППР'
  }
}
</script>
